import { getImageBaseUrl } from "../Utilities/Utilities";
import app_config from "../InitialSetup/AppConfig";

const Images = {
    S3_BUCKET_IMG_PATH: app_config.s3.BUCKET + "assets/img/",
    TEAM_JERSY: getImageBaseUrl('jersy.png'),
    COIN: getImageBaseUrl('coins.png'),
    LOGO: getImageBaseUrl('logo.png'),
    TEAM_HYDERABAD: getImageBaseUrl('Hyderabad.png'),
    TEAM_KOLKATA: getImageBaseUrl('Kolkata.png'),
    NODATA: getImageBaseUrl('nodata.png'),
    ADD_CASE : getImageBaseUrl('add-cash-ic.svg'),
    REFERAL_BG:getImageBaseUrl('referal_prize_bg.png'),
    BANNER_REFER_FRIEND: getImageBaseUrl('ic_refer_friend.svg'),
    BANNER_ADD_FUND: getImageBaseUrl('ic_add_funds.svg'),
    CHARACTER: getImageBaseUrl('character.png'),
    FEATURED_RECT: getImageBaseUrl('featured-rectangle.png'),
    WINNING_ICON: getImageBaseUrl('winning-ic.png'),
    USERIMG: getImageBaseUrl('mark_zuckerberg.png'),
    DEFAULT_USER: getImageBaseUrl('default-user.png'),
    DEFAULT_AVATAR: getImageBaseUrl('default_avatar.svg'),
    INFO_ICON : getImageBaseUrl('ic-info-white.svg'),
    PAYMENT_METHOD: getImageBaseUrl('payment-method.png'),
    QUE_LOGO: getImageBaseUrl('que-logo.png'),
    ITEM1: getImageBaseUrl('item1.png'),
    ITEM2: getImageBaseUrl('item2.png'),
    ITEM3: getImageBaseUrl('item3.png'),
    ITEM4: getImageBaseUrl('item4.png'),
    ITEM5: getImageBaseUrl('item5.png'),
    VIDEO_IMG: getImageBaseUrl('video1.png'),
    VIDEO_BTN: getImageBaseUrl('video-btn.png'),
    PLAYER_GRAPH: getImageBaseUrl('player_graph.png'),
    MINUS_IMG: getImageBaseUrl('remove-ic@1x.svg'),
    MOBILE_IMG: getImageBaseUrl('mobile.png'),
    LOGO_PBL: getImageBaseUrl('logo.png'),
    LOGO_GRAY: getImageBaseUrl('logo-gray.png'),
    LOGO_VINFOTECH: getImageBaseUrl('vinfotech-logo.png'),
    GOOGLE_PLAY: getImageBaseUrl('google-play.png'),
    defaultPanImage: getImageBaseUrl('default_Pan_Image.png'),

    teams_ic: getImageBaseUrl('teams-ic.png'),
    trophy_ic: getImageBaseUrl('trophy-ic.png'),
    clock_ic: getImageBaseUrl('clock-ic.png'),
    no_data_bg_image: getImageBaseUrl('circle-shape-png-hd-background-view-all-images.png'),
    no_notification: getImageBaseUrl('no-notification.png'),
    no_data: getImageBaseUrl('no_data.jpg'),

    // BEANS: require('./../assets/img/beans.png'),

    pinned_ic : getImageBaseUrl('pinned-ic.png'),
    CAPTAION_IC :  getImageBaseUrl('captain-ic.png'),
    VICE_CAPTAION_IC :  getImageBaseUrl('vice-captain-ic.png'),
    section3 : getImageBaseUrl('section3-bg.png'),
    htp1 : getImageBaseUrl('HTP-img1.svg'),
    htp2 : getImageBaseUrl('HTP-img2.svg'),
    htp3 : getImageBaseUrl('HTP-img3.svg'),
    FetureImg1 : getImageBaseUrl('feature-img1.png'),
    FetureImg2 : getImageBaseUrl('feature-img2.png'),
    FetureImg3 : getImageBaseUrl('feature-img3.png'),
    FetureImg4 :getImageBaseUrl('feature-img4.png'),
    FetureImg5 : getImageBaseUrl('feature-img5.png'),
    MobileAppImg : getImageBaseUrl('Mobile-app.png'),
    NotePad: getImageBaseUrl('notepad.png'),
    GMAIL_LOGO: getImageBaseUrl('gmail logo.png'),
    GPLUS_LOGO: getImageBaseUrl('google-logo.png'),
    SIGNUP_BANNER: getImageBaseUrl('offer-banner.png'),
    WALLET_IMG: getImageBaseUrl('wallet.png'),
    BRAND_LOGO_FULL: getImageBaseUrl('brand-logo.svg'),
    BRAND_LOGO_FULL_PNG: getImageBaseUrl('brand-logo.png'),
    BRAND_LOGO: getImageBaseUrl('brand-logo-header.svg'),
    FIELD_VIEW_LOGO: getImageBaseUrl('FieldView-logo.svg'),
    FIELD_VIEW_LOGO_KABADDI: getImageBaseUrl('FieldView-logo-kabaddi.svg'),
    WHITE_BRAND_LOGO: getImageBaseUrl('white-brand-logo-header.svg'),
    CRICKET_GROUND_BG: getImageBaseUrl('ground-cricket.svg'),
    VINFOTECH_BRAND: getImageBaseUrl('vinfotech-brand.png'),
    VINFOTECH_BRAND_WHITE: getImageBaseUrl('vinfotech-white-brand.png'),
    HEADER_SHADOW: getImageBaseUrl('header-shadow.png'),
    NO_INTERNET: getImageBaseUrl('no-internet.svg'),
    BTN_ANDROID_APP: getImageBaseUrl('btn-android-app.png'),
    SPORTS_MAN: getImageBaseUrl('Sport-man.png'),
    COLLECTION_INFO: getImageBaseUrl('collection-img.jpg'),
    COLLECTION_TEXT_IMG: getImageBaseUrl('Collection.png'),
    MULTIGAME_INFO: getImageBaseUrl('collection-info.svg'),
    MULTIGAME_INFO_CREATE_TEAM_LOGO: getImageBaseUrl('tshirt-collection.svg'),
    
    PLAY_STORE_BTN: getImageBaseUrl('appstore.png'),
    SOCIAL_NEWSFEED: getImageBaseUrl('social-newsfeed.png'),
    PBL_SCREEN: getImageBaseUrl('PBL_SCREEN.png'),
    FANTASY_SPORTS_GROUND: getImageBaseUrl('ground.png'),
    COUNTRY_FLAG: getImageBaseUrl('flag-ic.png'),
    LANGUAGE_IMG: getImageBaseUrl('language-img.png'),
    TICK_IC: getImageBaseUrl('tick-ic.svg'),
    PENDING_IC: getImageBaseUrl('pending-ic.svg'),
    BONUS_BANNER_BG: getImageBaseUrl('bonus-banner-bg.svg'),
    FAVOURITE: getImageBaseUrl('deal-badge-ic.svg'),
    CREDIT_IMG: getImageBaseUrl('credit-img.png'),
    PAYTM_IMG: getImageBaseUrl('Paytm_logo.png'),
    GOOGLE_PAY_IMG: getImageBaseUrl('google-pay.svg'),
    MOBILE_ICON: getImageBaseUrl('mobile-icon.svg'),
    MOBILE_ICON_WHITE: getImageBaseUrl('mobile-icon-white.svg'),
    EMAIL_ICON: getImageBaseUrl('email-icon.svg'),
    EMAIL_ICON_WHITE: getImageBaseUrl('email-icon-white.svg'),
    PAN_ICON: getImageBaseUrl('pancard-icon.svg'),
    PAN_ICON_PNG: getImageBaseUrl('pan-card-ic.png'),
    PAN_GRAY_ICON: getImageBaseUrl('pancard-icon-gray.svg'),
    BANK_ICON: getImageBaseUrl('bank-icon.svg'),
    CARD_IMG: getImageBaseUrl('cards-img@2x.png'),
    ICON_G: getImageBaseUrl('featured.png'),
    ICON_M: getImageBaseUrl('multiple.png'),
    QUES_ICON: getImageBaseUrl('ques-ic.png'),
    REFER_FRIEND: getImageBaseUrl('refer-friends.png'),
    REFER_FRIEND_SM: getImageBaseUrl('refer-friends-sm.png'),
    SPORTS_HUB: getImageBaseUrl('Sports_Hub.png'),
    REFER_FRIEND_HEADER: getImageBaseUrl('refer_friend_header.png'),
    REFER_FRIEND_SIGNUP : getImageBaseUrl('ref-friend-signup-icon.png'),
    REFER_FRIEND_DEPOSIT : getImageBaseUrl('on-friend-deposit.png'),
    REFER_FRIEND_REWARD : getImageBaseUrl('loyalty-reward.png'),
    COPY_CODE : getImageBaseUrl('copy.png'),
    ZIG_LINE :  getImageBaseUrl('zig-line.png'),
    DOT_LINE : getImageBaseUrl('dash-line-ln.png'),
    DOT_LINE_R : getImageBaseUrl('dash-line-ln-r.png'),
    REFER_IMG_SM : getImageBaseUrl('refer-img-sm.png'),
    COIN_SW1: getImageBaseUrl('1w-img.png'),
    COIN_SW2: getImageBaseUrl('2w-img.png'),
    COIN_SW3: getImageBaseUrl('3w-img.png'),
    W_IMG_COIN1: getImageBaseUrl('1w-img-coin.png'),
    W_IMG_COIN2: getImageBaseUrl('2w-img-coin.png'),
    W_IMG_COIN3: getImageBaseUrl('3w-img-coin.png'),
    SPIN_SW1: getImageBaseUrl('1w-spin.png'),
    SPIN_SW2: getImageBaseUrl('2w-spin.png'),
    EARN_COINS: getImageBaseUrl('earn-coins.png'),
    SILVR_EARN_COINS: getImageBaseUrl('silver-earn-coins.png'),
    CHECKIN_TICK: getImageBaseUrl('checkin-tick.png'),
    IC_COIN: getImageBaseUrl('ic-coin.png'),
    IC_COIN_GRAY: getImageBaseUrl('ic-coin-gray.png'),
    CHECKIN_COIN_PERSON: getImageBaseUrl('ccp.png'),
    COINS_POPUP_SHAPE: getImageBaseUrl('coins-popup-shape.png'),
    FEEDBACK_IC: getImageBaseUrl('feedback-img-ic.png'),
    REFER_IC: getImageBaseUrl('refer-img1.png'),
    PROMOTION_IC: getImageBaseUrl('promotion-img-ic.png'),
    PREDICTION_IC: getImageBaseUrl('prediction-img-ic.png'),
    CARD_BACK_IMG_DETAIL: getImageBaseUrl('card-back-img-detail.png'),
    CHECKIN_IC: getImageBaseUrl('checkins-img-ic.png'),
    COIN_CM: getImageBaseUrl('coins-couchmark.png'),
    COIN_LINE: getImageBaseUrl('line-img.png'),
    COIN_BAG: getImageBaseUrl('mega_contest.png'),
    COINS_ON_WALLET: getImageBaseUrl('coins-on-my-wallet@3x.png'),
    SINGLE_LINE: getImageBaseUrl('line-single.png'),
    BG_SHAP: getImageBaseUrl('background-shap.png'),
    COINS_BACK_STRIPE: getImageBaseUrl('coins-back-stripe.png'),
    FB_THUMB: getImageBaseUrl('feedback-ic.svg'),
    NEW_FEATURE_IC: getImageBaseUrl('new-ic.svg'),
    REFER_LOCK : getImageBaseUrl('lock-circle-ic.svg'),
    DAILY : getImageBaseUrl('daily.png'),
    DFS_SHAPE_IMG : getImageBaseUrl('dfs-shape-img.png'),
    DFS_IMG : getImageBaseUrl('dfs-img.png'),
    PRD_SHAPE_IMG : getImageBaseUrl('prd-shape-img.png'),
    PRD_IMG : getImageBaseUrl('prd-img.png'),
    PICKEM : getImageBaseUrl('pickem.png'),
    PREDICTION : getImageBaseUrl('prediction.png'),
    PREDICTION_BANNER : getImageBaseUrl('prediction_banner.jpg'),
    DFS_BANNER : getImageBaseUrl('dfs_banner.jpg'),
    PREDICTION_PRIZE_BANNER : getImageBaseUrl('prediction_prize_banner.jpg'),
    TOURNAMENT : getImageBaseUrl('tournament.png'),
    DELETE: getImageBaseUrl('delete.svg'),   
    SHUB_COUCHMARK : getImageBaseUrl('sportshub-couchmark.png'),
    PRE_CURVE : getImageBaseUrl('predictionn_curve.png'),
    PRD_PRIZE_IMG : getImageBaseUrl('prd-prize-img.png'),
    PRIZES_CAR : getImageBaseUrl('prizes-car.png'),
    TSHIRT_VS_IC : getImageBaseUrl('tshirt-vs-ic.png'),
    HELMET_IC : getImageBaseUrl('helmet-ic.png'),
    OPEN_PREDICTOR_BIG_IMG : getImageBaseUrl('open-predictor-img-big-img.png'),
    DAILY_BIG : getImageBaseUrl('daily-big.jpg'),
    PICKEM_BIG : getImageBaseUrl('pickem-big.png'),
    OPEN_PREDICTOR_NEW : getImageBaseUrl('open-predictor-new.png'),
    // NON_SPORTS_LABEL : getImageBaseUrl('non-Sports-label.svg'),

    REFER_LOCK : getImageBaseUrl('lock-circle-ic.svg'),
    LINK_COPY : getImageBaseUrl('link-ic.svg'),
    FACE_BOOK_ICON : getImageBaseUrl('fb-ic.svg'),
    SPECIAL_OFFER  : getImageBaseUrl('special-offer-label.png'), 
    THIN_ARROW  : getImageBaseUrl('arrow-thin-ic.svg'),
    THIN_ARROW_UP  : getImageBaseUrl('arrow-thin-ic-up.svg'), 
    OPEN_CARD_IMG_DETAIL  : getImageBaseUrl('dot-card-bg-img.png'), 
    ATTACHMENT_IC  : getImageBaseUrl('attchment-ic.svg'), 
    FIRST_RANK  : getImageBaseUrl('rank1.svg'), 
    SECOND_RANK  : getImageBaseUrl('rank2.svg'), 
    THIRD_RANK  : getImageBaseUrl('rank3.svg'), 
    AMAZON_IMG  : getImageBaseUrl('amazonimg.png'), 
    CONGRATS_IMG  : getImageBaseUrl('ribbon-bg-img.png'), 

    // Hall Of Fame F2P
    HALL_OF_FAME_BIG_ICON : getImageBaseUrl('hof-big-ic.png'),
    BG_HALL_OF_FAME : getImageBaseUrl('image_bg.png'),
    RIGHT_SHAPE : getImageBaseUrl('right_shape.png'),
    LEFT_SHAPE : getImageBaseUrl('left_shape.png'),
    HOF1 : getImageBaseUrl('hof-icon1.svg'),
    HOF2 : getImageBaseUrl('hof-icon2.svg'),
    HOF3 : getImageBaseUrl('hof-icon3.svg'),
    HALL_OF_FAME_SMALL_ICON :getImageBaseUrl('hof_small_icon.png'),
    IC_BONUS :getImageBaseUrl('bonus.png'),
    IC_INFO:getImageBaseUrl('ic-info.svg'),
    FOOTBALL_ICON : getImageBaseUrl('minileage_box.png'),
    STARS_ICON : getImageBaseUrl('stars.png'),
    IC1 : getImageBaseUrl('ic1.png'),
    IC2 : getImageBaseUrl('ic2.png'),
    IC3 : getImageBaseUrl('ic3.png'),
    IC4 : getImageBaseUrl('img.png'),
    PICK_EARNCOIN : getImageBaseUrl('pick-earncoin.jpg'),
    PREDICT_EARNCOIN : getImageBaseUrl('predict-earncoin.jpg'),



    DRAW_ICON : getImageBaseUrl('draw-icon.png'),
    PICKEM_HTP1 : getImageBaseUrl('pickemHTP1.png'),
    PICKEM_HTP2 : getImageBaseUrl('pickemHTP2.png'),
    PICKEM_HTP3 : getImageBaseUrl('pickemHTP3.png'),
    PICKEM_BANNER : getImageBaseUrl('Pickem-card-banner.png'),
    PICKEM_SHAPE_IMG : getImageBaseUrl('pickem-shape-img.png'),
    PICKEM_IMG : getImageBaseUrl('pickem-img.png'),
    BLUE_BG_IMG : getImageBaseUrl('blue-back-img.png'),
    DFS_BIG : getImageBaseUrl('DFS-big.png'),
    PICKEM_TOUR_IMG : getImageBaseUrl('pickem-tournament.jpg'),
    FTP_IMG : getImageBaseUrl('free-to-play.jpg'),
    MULTI_GAME_IMG : getImageBaseUrl('multi-game.jpg'),
    PRED_IMG : getImageBaseUrl('sport-prediction.jpg'),
    STOCK_FAN : getImageBaseUrl('stock-fantasy.jpg'),
    TOUR_MODE : getImageBaseUrl('tournament-mode.jpg'),
    MEN_IMG_REFER : getImageBaseUrl('men-img-refer.png'),
    EsportImg : getImageBaseUrl('EsportImg.png'),
    DFS_SIDE_IMG : getImageBaseUrl('daily-fantasy-side-Img.jpg'),
    OPEN_PRED_PP : getImageBaseUrl('open-predictor-prize-pool-Side.jpg'),
    OPEN_PRED_LEAD : getImageBaseUrl('open-predictor-leaderb-side-img.jpg'),
    APPLE_STORE_LOGO : getImageBaseUrl('applestore-logo.png'),
    APPLE_APP_STORE : getImageBaseUrl('apple_app_store.png'),
    TRACKING : getImageBaseUrl('tracking.png'),
    PROMOTION : getImageBaseUrl('promotion.png'),
    INDUS_LEAD : getImageBaseUrl('indus_lead.png'),
    COINIMG : getImageBaseUrl('coin-img.png'),
    DOWNLOAD_APP_BTN:getImageBaseUrl('download-app-btn.png'),
    DOWNLOAD_APPSTORE_BTN:getImageBaseUrl('appstore.png'),
    DOWNLOAD_PLAYSTORE_BTN:getImageBaseUrl('playstore.png'),
    GROUP_WALLET:getImageBaseUrl('group_wallet.png'),
    PHONE_PAY:getImageBaseUrl('phone_pay.png'),
    AXIS:getImageBaseUrl('axis.png'),
    KOTAK:getImageBaseUrl('kotak.png'),
    HDFC:getImageBaseUrl('hdfc.png'),
    ICIC:getImageBaseUrl('icic.png'),
    SBI:getImageBaseUrl('sbi.png'),
    UNION:getImageBaseUrl('union.png'),
    UPI:getImageBaseUrl('upi.png'),
    NET_BANKING:getImageBaseUrl('net_banking.png'),
    ZIG_ZAG_LINE:getImageBaseUrl('zig-zag-line.png'),
    REVERSE_FANTASY_ICON:getImageBaseUrl('reverse-fantasy-icon.png'),
    REVERSE_FANTASY_HTP:getImageBaseUrl('ReverseFantasyHTP.png'),
    RF_BANNER_IMG:getImageBaseUrl('RFBannerImg.png'),
    SCRATHC_COVER:getImageBaseUrl('scrathc_cover.png'),
    BRUSH:getImageBaseUrl('brush.png'),
    SCRATCH_SHAPE:getImageBaseUrl('scratch_shape.png'),
    TROPHY:getImageBaseUrl('trophy.png'),
    CELE:getImageBaseUrl('cele.png'),
    AIRTEL_MONEY:getImageBaseUrl('airtel-money.png'),
    FREECHARGE:getImageBaseUrl('free-charge.png'),
    PL_LOGO:getImageBaseUrl('PL-logo.png'),
    REMOVE_ICON:getImageBaseUrl('minus-img.png'),
    REFRESH_ICON:getImageBaseUrl('refresh-icon.png'),
    BLANK_JERSY:getImageBaseUrl('ic-blank-tshirt.png'),
    UNDO:getImageBaseUrl('undo.png'),
    LOCK_PLAYER:getImageBaseUrl('lock-player.png'),
    REMOVE_PLAYER_ROSTER:getImageBaseUrl('remove-player-guru.png'),
    GENRATE_TEAM:getImageBaseUrl('genrate-team.png'),
    REFRESH_TEAM:getImageBaseUrl('refresh-team.png'),
    MANAGE_PLAYER:getImageBaseUrl('manage-player.png'),
    SAVE_LINEUP:getImageBaseUrl('save-lineup.png'),
    PL1:getImageBaseUrl('pl1.png'),
    PL2:getImageBaseUrl('pl2.png'),
    PL3:getImageBaseUrl('pl3.png'),
    PL4:getImageBaseUrl('pl4.png'),
    PL5:getImageBaseUrl('pl5.png'),
    REVERT:getImageBaseUrl('revert.svg'),

    
    
    
}
export default Images;